import clsx from 'clsx';
import type { HTMLAttributes, Ref } from 'react';

import * as styles from './chart.css';

export interface ChartCardProps extends HTMLAttributes<HTMLDivElement> {}

export interface ChartCardHeaderProps extends HTMLAttributes<HTMLDivElement> {}

export interface ChartCardTitleProps
  extends HTMLAttributes<HTMLHeadingElement> {}

export interface ChartCardDescriptionProps
  extends HTMLAttributes<HTMLParagraphElement> {}

export interface ChartCardContentProps extends HTMLAttributes<HTMLDivElement> {}

export interface ChartCardFooterProps extends HTMLAttributes<HTMLDivElement> {}

export const ChartCard = ({
  ref,
  className,
  ...props
}: ChartCardProps & { ref?: Ref<HTMLDivElement> }) => (
  <div ref={ref} className={clsx(styles.chartCard, className)} {...props} />
);

export const ChartCardHeader = ({
  ref,
  className,
  ...props
}: ChartCardHeaderProps & { ref?: Ref<HTMLDivElement> }) => (
  <div
    ref={ref}
    className={clsx(styles.chartCardHeader, className)}
    {...props}
  />
);

export const ChartCardTitle = ({
  ref,
  className,
  ...props
}: ChartCardTitleProps & { ref?: Ref<HTMLHeadingElement> }) => (
  <h3 ref={ref} className={clsx(styles.chartCardTitle, className)} {...props} />
);

export const ChartCardDescription = ({
  ref,
  className,
  ...props
}: ChartCardDescriptionProps & { ref?: Ref<HTMLParagraphElement> }) => (
  <p
    ref={ref}
    className={clsx(styles.chartCardDescription, className)}
    {...props}
  />
);

export const ChartCardContent = ({
  ref,
  className,
  ...props
}: ChartCardContentProps & { ref?: Ref<HTMLDivElement> }) => (
  <div
    ref={ref}
    className={clsx(styles.chartCardContent, className)}
    {...props}
  />
);

export const ChartCardFooter = ({
  ref,
  className,
  ...props
}: ChartCardFooterProps & { ref?: Ref<HTMLDivElement> }) => (
  <div
    ref={ref}
    className={clsx(styles.chartCardFooter, className)}
    {...props}
  />
);
